import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useExport } from "@/hooks/importToolXSLX";

const ExportButton = ({ model, params, label = null, ...props }) => {
  const { t } = useTranslation();
  const { loading, handleExport } = useExport();

  return (
    <Button
      key="export"
      onClick={() => handleExport(model, params)}
      loading={loading}
      icon={<DownloadOutlined />}
      {...props}
    >
      {label ?? t("global:export")}
    </Button>
  );
};

ExportButton.propTypes = {
  model: PropTypes.string.isRequired,
  params: PropTypes.object,
  label: PropTypes.string,
};

export default ExportButton;
